<div class="popup">
    <div style="padding:10px;margin-bottom:70px;">

        <div class="modal-headerTitle" style="padding-left:10px; padding-top:10px; padding-bottom: 10px; text-align:center;">
            Setup Necessary
        </div>

        <div style="padding-left: 10px; padding-right: 10px; padding-bottom: 10px;" *ngIf=" Report.ReportFolder == '' && allowAutoRunReport && Report.AllowAutoRun" style="color:black;">
            <b>{{Report.Name}}</b> must be added to a report folder before being scheduled for Auto-Run. 
        </div>

        <div style="padding-left: 10px; padding-right: 10px; padding-bottom: 10px;" *ngIf="!allowAutoRunReport " style="color:black;">
            Scheduling Auto-Run reports is disabled. <br />
            Please contact your system administrator for more information.
        </div>

        <div style="padding-left: 10px; padding-right: 10px; padding-bottom: 10px;" *ngIf="!Report.AllowAutoRun && allowAutoRunReport " style="color:black;">
            Auto-Run is disabled for <b>{{Report.Name}}</b>. <br />
            Please contact your system administrator for more information.
        </div>

        <div style="padding-left: 10px; padding-right: 10px; padding-bottom: 10px;" *ngIf="Report.AutoRun == 'Y' && selectedFolderIds.length < 1" style="color:black;">
             <b>{{Report.Name}}</b> can not be removed from all report folders. <br />
            Please disable scheduled auto-runs first.
        </div>

        <div class="sis-app-footer">
            <tyl-button style="float:right;" image="cancel.png" label="Close" (clickEvent)="closeClick()"></tyl-button>
        </div>
        
    </div>
</div>
